import _ from 'underscore';

export const convertDataSelectionToArrayForm = (dataSelection) => {
  const temp = [...dataSelection];

  if (!temp) { return []; }

  const getSelectionAsString = (selection) => {
    if (!Array.isArray(selection)) { return String(selection); }
    if (selection[1] === true) { return String(selection[0]); }
    return undefined;
  };

  const result = _.chain(temp)
    .map(getSelectionAsString)
    .filter((item) => item !== undefined)
    .value();

  return result;
};
